import { useContext } from 'react';

// auth provider
import FirebaseContext from 'contexts/FirebaseContext';

const useAuth = () => useContext(FirebaseContext);

export default useAuth;
